module.exports = __webpack_public_path__ + "static/assets/fad_armrecording.svg";